<template>
  <div>
    <page-header :title="boardTitle" :description="getBoardDesc">
    </page-header>
    <div class="page-body pt-30 ph-30">

      <div class="box mt-20">
        <div class="box-header" style="display:flex;flex-direction:row">
          <div style="flex:1">
            <h3>{{item.title}}</h3>
          </div>
          <div>{{item.createUser}} {{getDate(item.modifiedDate)}}</div>
        </div>
        <div class="box-body">
           <div class="box border-box mb-10" v-for="(file, index) in item.fileList" :key="index">
            <div class="box-body">
              <button class="btn btn-m flat pull-right" style="margin:-3px -3px 0 0" @click="fileDownload(file)">
                <i class="icon-download"></i>
              </button>
              <i class="icon-image"></i>
              <span class="mh-5">{{file.fileName}}</span>
              <h5 class="d-inline-block">{{file.fileSize}}kb</h5>
            </div>
          </div>
          <form action="">
            <div class="form-group row">
              <div class="col-12" id="smart_editor2">
                <div class="se2_outputarea" v-html="item.content"></div>
              </div>
            </div>
          </form>

        </div>
      </div>
      <div class="btn-wrap mt-30 justify-content-center">
        <button v-if="$store.state.login.userLevel == 4" class="btn btn-lg blue" @click="edit()" >수정</button>
        <button class="btn btn-lg line-2" @click="list()">목록</button>
      </div>
    </div>
  </div>

</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import DataTableBase from '@/components/common/dataTableBase';
export default {
  mixins: [DataTableBase],
  props: ['boardTitle', 'boardName'],
  components: {
    PageHeader,


  },
  data(){
    return {
      getApi: 'board',
      data: {title: '공지사항', userName: '강선호', content: '동해물과 백두신이 마르고'}
    }
  },
  mounted(){
    this.init();
    var that = this;
    /*
    setTimeout(()=>{
      $('#smart_editor2').html(that.item.content);
    },2000)
    */
  },
  computed: {
    getDate(){
      return (date) =>{
        return moment(date).format(this.dateFormat);
      }
    },
    getBoardDesc(){
      return this.boardTitle + ' 목록입니다.';
    }
  },
  methods: {
    init(){

      this.item = {title: ''};
      this.getItemById(this.$route.params.id);
    },
    fileDownload(file){
        debugger;

        this.$http.get('/api/public/board/download/'+file.saveName, {responseType: 'blob'},)
          .then(function(result) {
            const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/octet-stream'}));
            const link = document.createElement('a');
            link.href = url;

            debugger;
            let fileName = file.fileName;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }.bind(this)).catch((e) =>{
            debugger;
            this.noti("다운로드 실패", "해당 파일을 찾을 수 없습니다.", 'warning');
          })
    },
    edit(){
      var query = Object.assign({},this.$route.query);
      //var query = {};
      query.mode = 'edit';
      this.$router.push({ path: '/app/' + this.boardName + '/'+ this.item.boardIndex, query:query})
    },
    list(){
      var query = Object.assign({},this.$route.query);
      query.mode = 'list';
      this.$router.push({ path: '/app/'+ this.boardName +'/', query: query})
    }
  }
}
</script>

<style>
ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
</style>
